import React from 'react'
import { Link } from 'react-router-dom'
import details_1 from '../../../assets/images/services/service-detail-1.jpg'
import details_2 from '../../../assets/images/services/service-detail-2.jpg'
import details_3 from '../../../assets/images/services/service-detail-3.jpg'
import details_4 from '../../../assets/images/services/service-details-icon-1.svg';
import details_5 from '../../../assets/images/services/service-details-icon-2.svg';
import details_6 from '../../../assets/images/services/service-details-arrow-right.svg'
import details_7 from '../../../assets/images/services/service-details-pre.svg'
import details_8 from '../../../assets/images/services/service-details-next.svg'
import details_9 from '../../../assets/images/services/service-details-icon-1.svg'
import details_10 from '../../../assets/images/services/service-details-icon-2.svg'
import Logos from '../../../assets/images/Logo.svg'

const Details = () => {
    return (
        <>
            <div className="service-details-section">
                <div className="container">
                    <div className="row gutter-x-15 gutter-y-30">
                        <div className="col-lg-8">
                            <div
                                className="service-details-block animate fadeInLeft wow"
                                data-wow-duration="1500ms"
                                data-wow-delay="200ms"
                            >
                                <h4>Business Intelligence</h4>
                                <p>
                                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                                    eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim
                                    ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut
                                    aliquip ex ea commodo consequat.
                                </p>
                                <p>
                                    Lesse cillum dolore eu fugiat nulla pariatur. Excepteur sint
                                    occaecat cupidatat non proident. Lorem ipsum dolor sit amet,
                                    consectetur adipiscing elit, sed do eiusmod tempor incididunt ut
                                    labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud
                                    exercitation ullamco laboris nisi ut aliquip ex ea commodo
                                    consequat.
                                </p>
                            </div>
                            <div
                                className="service-details-cta animate fadeInLeft wow"
                                data-wow-duration="1500ms"
                                data-wow-delay="400ms"
                            >
                                <p className="lead-lg">
                                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                                    eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim
                                    ad minim veniam, quis nostrud exercitation.
                                </p>
                            </div>
                            <div
                                className="service-details-block animate fadeInLeft wow"
                                data-wow-duration="1500ms"
                                data-wow-delay="500ms"
                            >
                                <p>
                                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                                    eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim
                                    ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut
                                    aliquip ex ea commodo consequat.
                                </p>
                            </div>
                            <div
                                className="service-details-block animate fadeInLeft wow"
                                data-wow-duration="1500ms"
                                data-wow-delay="600ms"
                            >
                                <img
                                    src={details_1}
                                    alt="services-image"
                                />
                            </div>
                            <div
                                className="service-details-block animate fadeInLeft wow"
                                data-wow-duration="1500ms"
                                data-wow-delay="800ms"
                            >
                                <h4>Management Style</h4>
                                <p>
                                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                                    eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim
                                    ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut
                                    aliquip ex ea commodo consequat.
                                </p>
                                <p>
                                    Lesse cillum dolore eu fugiat nulla pariatur. Excepteur sint
                                    occaecat cupidatat non proident. Lorem ipsum dolor sit amet,
                                    consectetur adipiscing elit, sed do eiusmod tempor incididunt ut
                                    labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud
                                    exercitation ullamco laboris nisi ut aliquip ex ea commodo
                                    consequat.
                                </p>
                            </div>
                            <div
                                className="service-details-block animate fadeInLeft wow"
                                data-wow-duration="1500ms"
                                data-wow-delay="1000ms"
                            >
                                <div className="service-details-tag-inner">
                                    <div className="service-details-tag">
                                        <span>
                                            <img
                                                src={details_9}
                                                alt="icon"
                                            />
                                        </span>
                                        <div className="service-details-tag-title">
                                            <h5>Growing Business</h5>
                                            <p>Finance helps you to convert into a strategic asset get.</p>
                                        </div>
                                    </div>
                                    <div className="service-details-tag">
                                        <span>
                                            <img
                                                src={details_10}
                                                alt="icon"
                                            />
                                        </span>
                                        <div className="service-details-tag-title">
                                            <h5>Finance Investment</h5>
                                            <p>Finance helps you to convert into a strategic asset get.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div
                                className="service-details-block animate fadeInLeft wow"
                                data-wow-duration="1500ms"
                                data-wow-delay="1200ms"
                            >
                                <h4>Explore our fintech solution offerings</h4>
                                <p>
                                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                                    eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim
                                    ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut
                                    aliquip ex ea commodo consequat.
                                </p>
                                <p>
                                    Lesse cillum dolore eu fugiat nulla pariatur. Excepteur sint
                                    occaecat cupidatat non proident. Lorem ipsum dolor sit amet,
                                    consectetur adipiscing elit, sed do eiusmod tempor incididunt ut
                                    labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud
                                    exercitation ullamco laboris nisi ut aliquip ex ea commodo
                                    consequat.
                                </p>
                            </div>
                            <div
                                className="service-details-block animate fadeInLeft wow"
                                data-wow-duration="1500ms"
                                data-wow-delay="1400ms"
                            >
                                <div className="service-details-image">
                                    <div className="service-details-image-inner">
                                        <img
                                            className="img-fluid"
                                            src={details_2}
                                            alt="service-image"
                                        />
                                    </div>
                                    <div className="service-details-image-inner">
                                        <img
                                            className="img-fluid"
                                            src={details_3}
                                            alt="service-image"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div
                                className="service-details-block animate fadeInLeft wow"
                                data-wow-duration="1500ms"
                                data-wow-delay="1500ms"
                            >
                                <p>
                                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                                    eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim
                                    ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut
                                    aliquip ex ea commodo consequat.
                                </p>
                            </div>
                            <div
                                className="service-details-block mb-0 animate fadeInLeft wow"
                                data-wow-duration="1500ms"
                                data-wow-delay="1600ms"
                            >
                                <div className="service-pagination-list">
                                    <div className="service-pagination pre">
                                        <div className="service-pagination-inner">
                                            <Link to="#">
                                                <img
                                                    src={details_7}
                                                    alt="icon"
                                                />
                                                <span>Previous</span>{" "}
                                            </Link>
                                            <h5>
                                                {" "}
                                                <Link to="#">Innovation space</Link>
                                            </h5>
                                        </div>
                                    </div>
                                    <div className="service-pagination next">
                                        <div className="service-pagination-inner">
                                            <Link to="#">
                                                <span>Next</span>
                                                <img
                                                    src={details_8}
                                                    alt="icon"
                                                />
                                            </Link>
                                            <h5>
                                                <Link to="#">Work organization</Link>
                                            </h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div >
                        <div className="col-lg-4">
                            <div className="service-details-sidebar">
                                <div
                                    className="service-details-widget animate fadeInRight wow"
                                    data-wow-duration="1500ms"
                                    data-wow-delay="200ms"
                                >
                                    <h4>Business Analysis</h4>
                                    <ul>
                                        <li>
                                            <p>Business Solution</p>{" "}
                                            <img
                                                src={details_6}
                                                alt="icon"
                                            />
                                        </li>
                                        <li>
                                            <p>Strategic Solutions</p>{" "}
                                            <img
                                                src={details_6}
                                                alt="icon"
                                            />
                                        </li>
                                        <li>
                                            <p>Finance Solution</p>{" "}
                                            <img
                                                src={details_6}
                                                alt="icon"
                                            />
                                        </li>
                                        <li>
                                            <p>Investment Policy</p>{" "}
                                            <img
                                                src={details_6}
                                                alt="icon"
                                            />
                                        </li>
                                        <li>
                                            <p>Tax Managment</p>{" "}
                                            <img
                                                src={details_6}
                                                alt="icon"
                                            />
                                        </li>
                                        <li>
                                            <p>Market Research &amp; Analysis</p>{" "}
                                            <img
                                                src={details_6}
                                                alt="icon"
                                            />
                                        </li>
                                    </ul>
                                </div>
                                <div
                                    className="service-details-cta-widget animate fadeInRight wow"
                                    data-wow-duration="1500ms"
                                    data-wow-delay="400ms"
                                >
                                    <img src={Logos} alt="icon" />
                                    <h5>Need Help? We Are Here To Help You</h5>
                                    <Link to="#" className="btn btn-primary btn-theme">
                                        Contact Us +
                                    </Link>
                                </div>
                            </div>
                        </div >
                    </div >
                </div >
            </div >

        </>
    )
}

export default Details
